<template>
  <div class="scroller">
    <div class="d-flex flex-column">
      <button v-scroll-to="{element: '#section1', easing: 'ease-in'}" class="dot colorful">1</button>
      <button v-scroll-to="{element: '#section2', easing: 'ease-in'}" class="dot colorful">2</button>
      <button v-scroll-to="{element: '#section3', easing: 'ease-in'}" class="dot colorful">3</button>
      <button v-scroll-to="{element: '#section4', easing: 'ease-in'}" class="dot colorful">4</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Scroller"
};
</script>

<style scoped lang="scss">
.scroller {
  z-index: 9999;;
  position: fixed;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: #0000006e;
  padding: 5px 10px;
  border-radius: 15px;
  .dot {
    background: transparent;
    border: none;
    cursor: pointer;;
    font-size: 1.5rem;
    transition: 0.2s;
    &:hover {
      transform: scale(1.5);
    }
    &:active {
      color: #fff;
    }
    &:focus {
      color: #fff;
      border: none;
      box-shadow: none;
      outline: none;
    }
  }
}
</style>
